var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedCandidate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17.9812V4.27875L15.7212 0H2.02C1.445 0.000833333 0.964583 0.19375 0.57875 0.57875C0.192916 0.96375 0 1.44417 0 2.02V17.98C0.000833333 18.5567 0.19375 19.0375 0.57875 19.4225C0.96375 19.8075 1.44417 20 2.02 20H17.98C18.5567 20.0008 19.0375 19.8083 19.4225 19.4225C19.8075 19.0367 20 18.5562 20 17.9812ZM15.1875 1.25L18.75 4.8125V17.98C18.75 18.205 18.6779 18.3896 18.5337 18.5337C18.3896 18.6779 18.2054 18.75 17.9812 18.75H2.02C1.795 18.75 1.61042 18.6779 1.46625 18.5337C1.32208 18.3896 1.25 18.2054 1.25 17.9812V4.8125V2.02C1.25 1.795 1.32208 1.61042 1.46625 1.46625C1.61042 1.32208 1.795 1.25 2.02 1.25H15.1875ZM11.7675 14.94C11.2783 15.4283 10.6892 15.6725 10 15.6725C9.3125 15.6742 8.72375 15.43 8.23375 14.94C7.74375 14.45 7.49917 13.8608 7.5 13.1725C7.50083 12.4842 7.74542 11.8954 8.23375 11.4062C8.72208 10.9171 9.31083 10.6729 10 10.6737C10.6892 10.6746 11.2779 10.9187 11.7662 11.4062C12.2546 11.8937 12.4992 12.4825 12.5 13.1725C12.5008 13.8625 12.2567 14.4517 11.7675 14.94ZM5 5H12V7H5V5ZM4 4H5H12H13V5V7V8H12H5H4V7V5V4Z",
    fill: "#4A4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedCandidate);
export default __webpack_public_path__ + "static/media/SavedCandidate.27eabacb3087c1b304737af230585d0b.svg";
export { ForwardRef as ReactComponent };